import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query"
import { AssetListType, getAssetList, getAssetModels } from "../asset"

// 生成资源的模型 / 风格配置
// staleTime 长缓存：多处组件（生成器/Agent/画布）共用，只拉一次；
// 生成成功后由调用方 invalidate 刷新剩余免费次数
export const assetModelsQueryOption = queryOptions({
  queryKey: ["asset", "models"],
  queryFn: () => getAssetModels(),
  staleTime: 10 * 60 * 1000,
})

const PAGE_SIZE = 20

// 资产列表（按类型分页；onlySuccess=1 只看生成成功）
export const assetListQueryOption = (type: AssetListType, onlySuccess: 0 | 1 = 0) =>
  infiniteQueryOptions({
    queryKey: ["asset", "list", type, onlySuccess],
    initialPageParam: { type, only_success: onlySuccess, page: 1, page_size: PAGE_SIZE },
    queryFn: async ({ pageParam }): Promise<any> =>
      (await getAssetList(pageParam)).data,
    getNextPageParam: (lastPage: any, _all, lastParam): any => {
      // 返回结构：{ total, page, list }，按 total 判断是否还有下一页
      const total = lastPage?.total ?? 0
      if (lastParam.page * lastParam.page_size >= total) return null
      return { ...lastParam, page: lastParam.page + 1 }
    },
    gcTime: 0,
    staleTime: 0
  })
